export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-480-5d47f27b89569bf3d361104909d31255.webp";